import { Color, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { EmptyResult } from '../../../../assets/images'
import * as Styled from './styles'

interface ExpertTrialBalanceSearchEmptyStateProps {
  text: string
}

export const ExpertTrialBalanceSearchEmptyState = ({ text }: ExpertTrialBalanceSearchEmptyStateProps): ReactElement => (
  <Styled.Wrapper>
    <Styled.Illustration>
      <EmptyResult />
    </Styled.Illustration>
    <Text alignment="center" color={Color.Grey800}>
      {text}
    </Text>
  </Styled.Wrapper>
)
